export interface DuplexSignals {
  live: true;
  peopleSpeaking: boolean;
  jabberrSpeaking: boolean;
  spoken: string;
}

/** A stale paid-session poll must never hide the voice worker's failure alert. */
export function professionalDuplexActive(active: boolean, workerState?: string): boolean {
  return active && workerState !== 'unavailable';
}

type AudioSignal = { audioLevel: number; isSpeaking: boolean };

/** Native DuplexSignals thresholds; input and output remain independent. No worker turn state. */
export function duplexSignals(professionalActive: boolean, muted: boolean, local?: AudioSignal, bot?: AudioSignal): DuplexSignals | null {
  if (!professionalActive) return null;
  const peopleSpeaking = !muted && !!local && (local.audioLevel > 0.04 || local.isSpeaking);
  const jabberrSpeaking = !!bot && (bot.audioLevel > 0.03 || bot.isSpeaking);
  const spoken = peopleSpeaking && jabberrSpeaking ? 'Live. You and Jabberr are both talking.'
    : jabberrSpeaking ? 'Live. Jabberr is talking.'
    : peopleSpeaking ? 'Live. Jabberr hears you.'
    : 'Live. Jabberr is listening and can speak at any time.';
  return { live: true, peopleSpeaking, jabberrSpeaking, spoken };
}
